// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"93550949","977":"831dd144"}[chunkId] + ".chunk.js";
};